export default __webpack_public_path__ + "static/media/Group842.1adf472d.svg";